import moment from 'moment';
import { constant } from './constants';
import translation from '../../utils/translation';
import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Popconfirm, Tooltip, message } from 'antd';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ChatListContainer, ChatRow, SidebarContainer } from './CSS/styles';
import { createConversation, getChatList, deleteConversationId } from './Utils/ApICalls';

const Sidebar = ({ onChatSelected, selectedChatId }) => {
  // State hooks
  const [chatList, setChatList] = useState([]);
  const [collapsed, setCollapsed] = useState(true);

  // Redux selectors
  const translationCache = useSelector(state => state.TranslationReducer.translationCache);
  const currentTimeZone = useSelector(state => state.LayoutReducer.currentTimeZone);

  // Fetch chat list on component mount
  useEffect(() => {
    fetchChatList();
  }, []);

  // Fetch chat list function
  const fetchChatList = async () => {
    try {
      const chatListResponse = await getChatList();
      setChatList(chatListResponse);
    } catch (error) {
      console.error('Error fetching chat list:', error);
    }
  };

  // Create new chat handler
  const onCreateChat = async () => {
    try {
      const saveResponse = await createConversation();
      if (saveResponse && saveResponse.Id) {
        fetchChatList();
        onChatSelected(saveResponse.Id);
      } else {
        message.error('Failed to create chat');
      }
    } catch (error) {
      console.error('Error creating chat:', error);
      message.error('Error creating chat');
    }
  };

  // Delete chat handler
  const onDeleteChat = async (e, chatId) => {
    e.preventDefault();
    try {
      const deleteObject = await deleteConversationId(chatId);
      if (deleteObject && deleteObject.message) {
        message.success(deleteObject.message);
        fetchChatList();
      }
    } catch (error) {
      console.error('Error deleting chat:', error);
    }
  };

  // Render
  const collapseWidth = collapsed === true;

  return (
    <SidebarContainer $collapseWidth={collapseWidth}>
      {!collapsed && (
        <ChatListContainer>
          <Button onClick={onCreateChat}>
            + {translation(translationCache, constant.New_Chat)}
          </Button>
          {chatList?.map((chat) => (
            <ChatRow
              key={chat.Id}
              onClick={() => onChatSelected(chat.Id)}
              $isSelected={chat.Id === selectedChatId}
            >
              <span>
                {chat.CreatedTime
                  ? moment(chat.CreatedTime)
                    .tz(currentTimeZone)
                    .format('YYYY-MM-DD HH:mm:ss')
                  : ''}
              </span>
              <Popconfirm
                placement="topLeft"
                title="Are you sure to delete this conversation?"
                onConfirm={(e) => onDeleteChat(e, chat.Id)}
                okText="Yes"
                cancelText="No"
              >
                <FontAwesomeIcon icon={faTrash} />
              </Popconfirm>
            </ChatRow>
          ))}
        </ChatListContainer>
      )}
      <div
        className="antdcollapsed-button"
        onClick={() => setCollapsed(!collapsed)}
      >
        {collapsed ? (
          <Tooltip
            placement="top"
            title={translation(translationCache, constant.Open)}
          >
            <RightOutlined />
          </Tooltip>
        ) : (
          <Tooltip
            placement="top"
            title={translation(translationCache, constant.Close)}
          >
            <LeftOutlined />
          </Tooltip>
        )}
      </div>
    </SidebarContainer>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});
export default connect(mapStateToProps)(Sidebar);
